module.exports = ".fixed-action-btn {\n    right: 20px;\n    bottom: 90%;\n} \n\n.btn-toggle, .btn-item {\n    background-color: #0B0B3B !important;\n} \n\n@media only screen and (max-width: 500px) {\n    li {\n        margin-right: 1px !important;\n    }\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/portal-cmcti/portal-cmcti.component.css
// module id = ./src/app/portal-cmcti/portal-cmcti.component.css
// module chunks = main